import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
// external libraries
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { motion } from 'framer-motion';
// utils
import { initialsUpperCase } from 'utils/textFormat';
import { handleAPIError, handleCatchError } from 'utils/handleErrors';
// api
import { getCounters } from '../../api/Api-user';
// components
import ShippingRefundModal from './components/ShippingRefundModal';
import VideoModal from './components/VideoModal';
import CounterCard from './components/CounterCard';
import Loading from '../../components/loading/LoadingRed';
import ShipmentCard from './components/ShipmentCard';
import DashboardCard from '../../components/cards/DashboardCard';
import IncidentTypeModal from '../support/components/IncidentTypeModal';
import NotificationGallery from '../../components/carousel/NotificationsGallery';
import WarningModal from './components/WarningModal';

const Dashboard = () => {
  const title = 'Inicio';
  const description = 'Inicio Plataforma Ioenvio';
  const history = useHistory();
  // - Local States
  const [counters, setCounters] = useState({
    balance: 0,
    shippings: 0,
    pickups: 0,
  });
  const [lastShippings, setLastShippings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isAwareWarning, setIsAwareWarning] = useState(() => {
    return localStorage.getItem('isAwareWarning') === 'true';
  });

  const [isWarningModalOpen, setIsWarningModalOpen] = useState(!isAwareWarning);

  // - Global State from Store.js form Values
  const { isLogin, currentUser } = useSelector((state) => state.auth);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  // console.log('current user:', currentUser);
  // console.log('token desde el storage:', JSON.parse(JSON.parse(localStorage.getItem('persist:starter-project')).auth).currentUser.api_key_production);
  if (!isLogin) {
    history.push('/login');
    // history.goBack();
  }
  const cardVariants = {
    hidden: { opacity: 0, y: 50 }, // Empieza invisible y desplazado hacia abajo
    visible: { opacity: 1, y: 0 }, // Se vuelve visible y se posiciona
  };
  const handleModalClose = () => {
    setIsAwareWarning(true);
    setIsWarningModalOpen(false);
    localStorage.setItem('isAwareWarning', 'true');
  };
  const handlerGetCounters = async () => {
    try {
      setIsLoading(true);
      const response = await getCounters();
      // console.log('response counters:', response);
      if (response.current_balance !== undefined) {
        setCounters({
          balance: response.current_balance,
          shippings: response.shippings_counter_last_month,
          pickups: response.pickups_counter_last_month,
        });
        setLastShippings(response.shippings);
        // setLastPickups(response.pickups);
        setNotifications(response.notices);
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    handlerGetCounters();
  }, []);
  // useEffect(() => {
  //   // handlerGetCounters();

  //   // 🔥 Datos de prueba
  //   setLastShippings([
  //     {
  //       id: 1,
  //       shipping_label_id: 'ENV123456',
  //       shipping_code: 'DHL_EXPRESS',
  //       service_img: 'https://via.placeholder.com/80x80?text=DHL',
  //       creation_date: new Date(),
  //       refunded: false,
  //       shipping_rates: {
  //         total: 150.5,
  //       },
  //     },
  //     {
  //       id: 2,
  //       shipping_label_id: 'ENV789012',
  //       shipping_code: 'FEDEX_PRIORITY',
  //       service_img: 'https://via.placeholder.com/80x80?text=FEDEX',
  //       creation_date: new Date(),
  //       refunded: true,
  //       shipping_rates: {
  //         total: 230,
  //       },
  //     },
  //   ]);
  // }, []);
  console.log('contadores:', counters);
  useEffect(() => {
    if (!isAwareWarning) {
      setIsWarningModalOpen(true);
    }
  }, [isAwareWarning]);
  return (
    <>
      <ShippingRefundModal setIsRefundModalOpen={setIsRefundModalOpen} isRefundModalOpen={isRefundModalOpen} />
      <IncidentTypeModal isModalOpen={isReportModalOpen} setIsModalOpen={setIsReportModalOpen} />
      {/* Warning Modal */}
      {/* <WarningModal isOpen={isWarningModalOpen} onClose={handleModalClose} /> */}
      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        videoId="YSbmX0oNCUU" // ID del video de YouTube
      />
      <HtmlHead title={title} description={description} />
      {/* Title Start */}

      <div>
        <Row className="g-4 align-items-stretch">
          {/* COLUMNA IZQUIERDA */}
          <Col xs="12" lg="6" className="d-flex flex-column">
            {/* Saludo + counters */}
            <div className="bg-azul d-grid p-3 pt-0 rounded-10 mb-4">
              <div className="my-4 page-title-container d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <h2
                  className="mb-0 pb-0 display_c-6 text-center text-sm-start lh-base text-white"
                  id="title"
                >
                  {`¡Hola ${initialsUpperCase(currentUser.name)}!`}
                </h2>

                <div className="mt-3 mt-md-0 d-flex justify-content-end w-100 w-md-auto">
                  <NavLink
                    to="/envios/enviar"
                    className="btn d-flex gap-2 align-items-center justify-content-center btn-over-primary"
                    id="goform"
                  >
                    <span>Crear envío</span>
                    <CsLineIcons icon="plus_add" size="15" className="me-1" />
                  </NavLink>
                </div>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: 'easeOut' }}
              >
                <Row className="mb-0 row-gap-4 d-flex flex-wrap justify-content-around">
                  <CounterCard
                    icon="saldo"
                    title="saldo actual"
                    counter={counters.balance}
                    tooltip="Ir a Movimientos"
                    path="/finanzas/movimientos"
                  />
                  <CounterCard
                    icon="card"
                    title="clabe stp"
                    counter={currentUser.clabe}
                  />
                  <CounterCard
                    icon="truck"
                    title="Envíos del mes"
                    counter={counters.shippings}
                    tooltip="Ir a Historial de envíos"
                    path="/envios/historial"
                  />
                  <CounterCard
                    icon="home"
                    title="recolecciones del mes"
                    counter={counters.pickups}
                    tooltip="Ir a Historial de recolecciones"
                    path="/envios/recolectar"
                  />
                </Row>
              </motion.div>
            </div>

            {/* Notificaciones / aviso */}
            <div className="flex-grow-1 d-flex flex-column justify-content-end">
              <div style={{ minHeight: '150px' }}>
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <Loading />
                  </div>
                ) : (
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: 'easeOut' }}
                  >
                    {notifications.length > 0 && (
                      <>
                        <p className="text-primary fw-semibold mb-2">Avisos importantes</p>
                        <NotificationGallery notifications={notifications} />
                      </>
                    )}
                  </motion.div>
                )}
              </div>
            </div>
          </Col>

          {/* COLUMNA DERECHA */}
          <Col xs="12" lg="6" className="d-flex flex-column">
            {/* Últimos envíos */}
            <div
              className="bg-infox d-flex flex-column gap-2 overflow-auto mb-0"
              style={{ minHeight: '100px', maxHeight: '635px' }}
            >
              <p className="text-muted mb-2">Últimos envíos realizados</p>

              {isLoading && (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                  <Loading />
                </div>
              )}

              {!isLoading && lastShippings.length === 0 && (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                  <p>No hay envíos recientes</p>
                </div>
              )}

              {!isLoading &&
                lastShippings.length > 0 &&
                lastShippings.map((shipping, index) => (
                  <motion.div
                    key={shipping.id}
                    initial="hidden"
                    animate="visible"
                    transition={{
                      duration: 0.5,
                      delay: index * 0.2,
                    }}
                    variants={cardVariants}
                    className="w-100"
                  >
                    <ShipmentCard shipping={shipping} />
                  </motion.div>
                ))}
            </div>

            {/* Reembolso */}
            <Card
              className="hover-img-scale-up border-blue mt-auto"
              style={{ minHeight: '220px', backgroundColor: '#f1f1f1' }}
            >
              <Card.Body className="d-flex flex-column justify-content-between align-items-start bg-white card-img-overlay">
                <div className="min-h-75">
                  <div className="cta-3">¿Guía sin usar?</div>
                  <div className="mb-1 cta-3 text-primary">Reembolso de guías</div>
                  <div className="text-alternate mb-0">
                    Facilitamos tu reembolso de guías con un proceso simple y sin complicaciones.
                  </div>
                </div>

                <img
                  src="/img/autopaquete/enviar/carddash/reembolso.webp"
                  className="w-50 object-fit-contain scale mt-2"
                  style={{ objectPosition: 'left', height: '50px' }}
                  alt="card image"
                />

                <Button
                  data-gtm="init-cancellations"
                  className="btn-icon w-auto btn-primary text-primary p-0 mt-2 text-left border-0 bg-white btn-icon-start ms-0"
                  onClick={() => {
                    setIsRefundModalOpen(true);
                  }}
                >
                  <CsLineIcons icon="plus_add" />
                  <span className="ps-2">Solicitar reembolso</span>
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>


    </>
  );
};

export default Dashboard;
